'use strict';

module.exports = function firstWhere(key, operator, value) {
  return this.where(key, operator, value).first() || null;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/firstWhere.js
// module id = 1658
// module chunks = 2